import React, {Component} from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { withRouter } from "../utils/withRouter";
import { Form } from "react-router-dom";
import CommonService from "../services/common.service";
import userEventService from "../services/user-event.service";

let common = new CommonService();

interface LoginPageState {
    user: string;
    password?: string;
    translations: Record<string, any>;
}

interface LoginPageProps {
}

class LoginPage extends Component<LoginPageProps, LoginPageState> {
    constructor(props: LoginPageProps) {
        super(props);
        this.state = {
            user: '',
            password: '',
            translations: JSON.parse(localStorage.getItem('translations') || '[]')
        };
    }
    
    componentDidMount(): void {
        userEventService.sendEvent('page_view', 'login_page_open');
    }

    private navigatePage(url: string) {
        window.location.href = url;
    }

    private authUser() {
        common.authenticateUser(this.state.user, this.state.password || '').then((res) => {
            console.log(res);
            if (res.success === true) {
                localStorage.setItem('username', res.name);
                localStorage.setItem('hotel', res.hotel);
                this.navigatePage('/');
            } else {
                alert(this.state.translations.filter((item: any) => item.setting_name === 'LOGIN_FAILED')[0].setting_value_text || 'Login failed. Please check your credentials.');
            }
        }).catch((err) => {
            console.error("Failed to authenticate user:", err);
        });
    }

    render() {
        return (
            <Container className="oc-cart">
                <Row key={1} className="oc-page-title">
                    <Col lg={8} md={12} sm={12} xs={12}>
                        <h2>{this.state.translations.filter((item: any) => item.setting_name === 'LOGIN')[0].setting_value_text}</h2>
                    </Col>
                </Row>
                <Row key={2} className="oc-login">
                    <Col lg={4} md={6} sm={12} xs={12}>
                        <Row key={3}>
                            <Col lg={12} md={12} sm={12} xs={12}>
                                <input type="text" className="form-control login-input" placeholder={this.state.translations.filter((item: any) => item.setting_name === 'USERNAME')[0].setting_value_text} value={this.state.user} onChange={(e) => this.setState({user: e.target.value})} />
                            </Col>
                        </Row>
                        <Row key={4}>
                            <Col lg={12} md={12} sm={12} xs={12}>
                                <input type="password" className="form-control login-input" placeholder={this.state.translations.filter((item: any) => item.setting_name === 'PASSWORD')[0].setting_value_text} value={this.state.password} onChange={(e) => this.setState({password: e.target.value})} />
                            </Col>
                        </Row>
                        <Row key={5}>
                            <Col lg={12} md={12} sm={12} xs={12}>
                                <Button variant="primary" className="oc-btn-checkout full-width separate" onClick={() => this.authUser()}>{this.state.translations.filter((item: any) => item.setting_name === 'LOGIN')[0].setting_value_text}</Button>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default withRouter(LoginPage);